module.exports = __webpack_public_path__ + "static/7-a4a2c526529c2b955a686273301b4d69.jpg";